import React, { useState, useEffect, useCallback } from 'react'
import { Button, Col, Divider, Dropdown, Row, Space, Table, Tooltip, Typography } from 'antd'
import { DeleteOutlined, CheckCircleOutlined, MoreOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/Auth'
import axios from 'axios';
import ExpandedData from './ExpandedData'

const { Title, Text } = Typography

const All = () => {

    const { user, getApiConfig } = useAuthContext()
    const [documents, setDocuments] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [status] = useState("received")

    const readDocuments = useCallback(async () => {
        setIsLoading(true)
        axios.get(`${window.api}/messages/all?status=${status}`, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    const array = data.messages.map(message => ({ ...message, key: message.id }))
                    setDocuments(array)
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while getting the messages", "error")
            })
            .finally(() => {
                setIsLoading(false)
            })
    }, [getApiConfig, status])
    useEffect(() => { readDocuments() }, [readDocuments])

    const handleDelete = (row) => {
        axios.delete(`${window.api}/messages/single/${row.id}`, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    window.toastify(data.message, "success")
                    const filteredDocuments = documents.filter(item => item.id !== row.id)
                    setDocuments(filteredDocuments)
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while deleting the message", "error")
            })
    }
    const handleMarkRead = (row) => {
        axios.patch(`${window.api}/messages/update-read/${row.id}`, {}, getApiConfig())
            .then((res) => {
                const { data, status } = res
                if (status === 200) {
                    window.toastify(data.message, "success")
                }
            })
            .catch(error => {
                console.error(error)
                window.toastify(error.response?.data?.message || "Something went wrong while updating the message", "error")
            })
    }

    const columns = [
        { title: 'Name', dataIndex: 'fullName' },
        { title: 'Email', dataIndex: 'email' },
        { title: 'Phone', dataIndex: 'phone', render: (item, row) => <a href={`tel:+${item}`} target="_blank" rel="noopener noreferrer">{item}</a> },
        { title: 'WhatsApp', dataIndex: 'whatsapp', render: (item, row) => <a href={`https://wa.me/${item}`} target="_blank" rel="noopener noreferrer">{item}</a> },
        { title: 'Country', dataIndex: 'country', align: "center", render: (item, row) => <Text className='text-capitalize'>{item?.name}</Text>, },
        { title: 'Province', dataIndex: 'province', align: "center", render: (item, row) => <Text className='text-capitalize'>{item?.name}</Text>, },
        { title: 'City', dataIndex: 'city', align: "center", render: (item, row) => <Text className='text-capitalize'>{item?.name}</Text>, },
        {
            title: 'Action', align: "center",
            render: (_, row) => (
                <Dropdown
                    menu={{
                        items: [
                            { label: "Delete", icon: <DeleteOutlined />, onClick: () => { handleDelete(row) } },
                            { label: "Mark as read", icon: <CheckCircleOutlined />, onClick: () => { handleMarkRead(row) } },
                        ]
                    }}
                    trigger={['click']}
                >
                    <MoreOutlined className='text-primary' />
                </Dropdown>
            ),
        },
    ]

    return (
        <>
            <Row className='mb-3'>
                <Col>
                    <Title level={3} className="mb-0">Messages</Title>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card">
                        <Row>
                            <Col span={24} className="d-flex justify-content-end align-items-center">
                                <Space size="small">
                                    <Tooltip title="Refresh Messages"><Button icon={<ReloadOutlined />} onClick={readDocuments} /></Tooltip>
                                </Space>
                            </Col>
                        </Row>

                        <Divider />

                        <Table
                            columns={columns.filter((item) => !item.allowedroles || user.roles?.find(role => item.allowedroles?.includes(role)))}
                            dataSource={documents}
                            loading={isLoading}
                            scroll={{ x: true }}
                            size="small"
                            expandable={{ expandedRowRender: (row) => <ExpandedData data={row} /> }}
                        />
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default All